var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCicd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cicd-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.9,24h0a2,2,0,0,0-2,1.8A18,18,0,0,1,24,42a17.6,17.6,0,0,1-12.7-5.3l1.4-1.4a16,16,0,0,0,27.1-9,2,2,0,1,0-3.9-.6,12,12,0,0,1-20.4,6.8l1.8-1.8a1,1,0,0,0-.7-1.7H5V40.6a1,1,0,0,0,1.7.7l1.7-1.7A22.3,22.3,0,0,0,24,46,22,22,0,0,0,45.9,26.2,2,2,0,0,0,43.9,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,22.2A18,18,0,0,1,24,6a17.6,17.6,0,0,1,12.7,5.3l-1.4,1.4a16,16,0,0,0-27.1,9,2,2,0,1,0,3.9.6,12,12,0,0,1,20.4-6.8l-1.8,1.8a1,1,0,0,0,.7,1.7H43V7.4a1,1,0,0,0-1.7-.7L39.6,8.4A22.3,22.3,0,0,0,24,2,22,22,0,0,0,2.1,21.8a2,2,0,0,0,2,2.2h0A2,2,0,0,0,6.1,22.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,24a6,6,0,1,0,6-6A6,6,0,0,0,18,24Zm8,0a2,2,0,1,1-2-2A2,2,0,0,1,26,24Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicd);
export default __webpack_public_path__ + "static/media/cicd.7e25688a96d4e14c5dbe3d787542b5c6.svg";
export { ForwardRef as ReactComponent };